<template>
  <div class="satisfaction-breakdown align-center d-flex align-center justify-center">
    <div class="text-center mb-4 d-flex flex-row align-center ga-6">
      <v-progress-circular :model-value="data.likePercentage" :size="140" :width="14" color="success" class="satisfaction-circle">
        <div class="d-flex flex-column align-center">
          <div class="text-h4 font-weight-bold text-success">{{ data.likePercentage }}%</div>
          <div class="text-caption text-medium-emphasis">Satisfaction</div>
        </div>
      </v-progress-circular>

      <div class="">
        <v-col cols="" class="text-center">
          <div class="d-flex align-center justify-center mb-1">
            <v-icon color="success" size="20" class="mr-1">mdi-thumb-up</v-icon>
            <span class="text-caption text-medium-emphasis">LIKE</span>
          </div>
          <div class="text-h5 font-weight-bold text-success">{{ formatNumber(data.like) }}</div>
        </v-col>
        <v-col cols="" class="text-center">
          <div class="d-flex align-center justify-center mb-1">
            <v-icon color="error" size="20" class="mr-1">mdi-thumb-down</v-icon>
            <span class="text-caption text-medium-emphasis">DISLIKE</span>
          </div>
          <div class="text-h5 font-weight-bold text-error">{{ formatNumber(data.dislike) }}</div>
        </v-col>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SatisfactionBreakdown',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatNumber(num) {
      return num?.toLocaleString('en-US') || '0';
    },
  },
};
</script>

<style scoped>
.satisfaction-breakdown {
  width: 100%;
}

.satisfaction-circle {
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
}
</style>
